import {
  IncidentState_WorkingOnResolution_getInstance2xzbjm5gfjniq as IncidentState_WorkingOnResolution_getInstance,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  IncidentState_Filed_getInstanceg9puzn4wq1pv as IncidentState_Filed_getInstance,
  EscalationLevel_Issue_getInstancea8pbpo27up2o as EscalationLevel_Issue_getInstance,
  EscalationLevel_Disputed_getInstance3pwh4crkd38ie as EscalationLevel_Disputed_getInstance,
} from '../enums.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_DAYS_getInstance3abv9r3rbwkq3 as DurationUnit_DAYS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  Appealxiso3o25clbz as Appeal,
  RequestSiteVisit2qqplegjmdj5x as RequestSiteVisit,
  NotResponsible5sod6b685ij0 as NotResponsible,
  Accept3c5lxev9vmal1 as Accept,
  NeedsApproval209x3ip39ndz6 as NeedsApproval,
  MoreInfo_instancelndi8wb3mxe1 as MoreInfo_instance,
  FileIncident88pwqv67k7mz as FileIncident,
  ClientResponsexqxw1r0z235j as ClientResponse,
  get_isSignOff4lsphp4dtm8l as get_isSignOff,
} from './IncidentResponseType.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toMutableList20rdgwi7d3cwi as toMutableList,
  reversed22y3au42jl32b as reversed,
  firstOrNull1982767dljvdy as firstOrNull,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  takeLasttm5u17ojwaaq as takeLast,
  dropLast1vpiyky649o34 as dropLast,
  last1vo29oleiqj36 as last,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Companion_getInstance1twm7uvvfawb7 as Companion_getInstance_0 } from '../supportModels.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var IncidentFlowPermissionsClass;
function IncidentFlowPermissions() {
  if (IncidentFlowPermissionsClass === VOID) {
    class $ {
      constructor(project, incident, rawMessages, isClient, role) {
        this.j9d_1 = project;
        this.k9d_1 = incident;
        this.l9d_1 = isClient;
        this.m9d_1 = role;
        this.n9d_1 = IncidentHistory().m9e(this.k9d_1, rawMessages);
        var tmp = this;
        var tmp0_safe_receiver = this.n9e();
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z67_1;
        tmp.o9d_1 = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
        this.p9d_1 = !this.o9d_1;
        var tmp_0 = this;
        var tmp_1;
        if (!this.l9d_1 && !(this.m9d_1 == null) && this.m9d_1.d4(MemberRole_Manager_getInstance()) >= 0) {
          var tmp0_safe_receiver_0 = this.k9d_1;
          tmp_1 = equals(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.k63_1, IncidentState_WorkingOnResolution_getInstance());
        } else {
          tmp_1 = false;
        }
        tmp_0.q9d_1 = tmp_1;
        this.r9d_1 = this.o9d_1 || this.q9d_1;
        this.s9d_1 = this.l9d_1 && this.p9d_1 || (!this.l9d_1 && !(this.m9d_1 == null) && this.m9d_1.d4(MemberRole_Manager_getInstance()) >= 0 && this.r9d_1);
        this.t9d_1 = (this.l9d_1 && this.k9d_1 == null);
        var tmp_2 = this;
        var tmp_3;
        if (this.u8w() && !this.v8w()) {
          // Inline function 'kotlin.let' call
          var it = this.n9e();
          var tmp_4;
          if (!(it == null) && !it.z67_1) {
            // Inline function 'com.lightningkite.now' call
            var tmp_5 = get_default(Companion_instance).d1m();
            // Inline function 'kotlin.time.Companion.days' call
            Companion_getInstance();
            var tmp$ret$1 = toDuration(5, DurationUnit_DAYS_getInstance());
            tmp_4 = it.e68_1.y26(tmp_5.w26(tmp$ret$1)) <= 0;
          } else {
            tmp_4 = false;
          }
          tmp_3 = tmp_4;
        } else {
          tmp_3 = false;
        }
        tmp_2.u9d_1 = tmp_3;
        var tmp_6 = this;
        var tmp_7;
        if (this.u8w() && !this.v8w()) {
          var tmp_8;
          var tmp0_safe_receiver_1 = this.k9d_1;
          if ((tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.l63_1) === true) {
            tmp_8 = true;
          } else {
            tmp_8 = this.p9d_1;
          }
          tmp_7 = tmp_8;
        } else {
          tmp_7 = false;
        }
        tmp_6.v9d_1 = tmp_7;
        this.w9d_1 = this.l9d_1 && this.v9d_1 || (!this.l9d_1 && this.u9d_1);
        var tmp_9 = this;
        var tmp_10;
        if (this.w9d_1) {
          var tmp_11;
          var tmp_12;
          var tmp0_safe_receiver_2 = this.n9e();
          var tmp_13 = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.f94();
          if (tmp_13 instanceof RequestSiteVisit()) {
            tmp_12 = true;
          } else {
            var tmp1_safe_receiver = this.n9e();
            var tmp_14 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f94();
            tmp_12 = tmp_14 instanceof Appeal();
          }
          if (tmp_12) {
            tmp_11 = true;
          } else {
            var tmp2_safe_receiver = this.n9e();
            var tmp_15 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.f94();
            tmp_11 = tmp_15 instanceof NotResponsible();
          }
          tmp_10 = tmp_11;
        } else {
          tmp_10 = false;
        }
        tmp_9.x9d_1 = tmp_10;
        var tmp_16 = this;
        var tmp_17;
        var tmp0_safe_receiver_3 = this.k9d_1;
        if ((tmp0_safe_receiver_3 == null ? null : tmp0_safe_receiver_3.m63_1) === true) {
          var tmp1_safe_receiver_0 = this.m9d_1;
          var tmp_18;
          if (tmp1_safe_receiver_0 == null) {
            tmp_18 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_18 = tmp1_safe_receiver_0.d4(MemberRole_Manager_getInstance()) >= 0;
          }
          var tmp2_elvis_lhs = tmp_18;
          tmp_17 = tmp2_elvis_lhs == null ? this.l9d_1 : tmp2_elvis_lhs;
        } else {
          tmp_17 = false;
        }
        tmp_16.y9d_1 = tmp_17;
        var tmp_19 = this;
        var tmp_20;
        if (this.s9d_1 && this.v8w()) {
          var tmp0_safe_receiver_4 = this.n9e();
          var tmp_21 = tmp0_safe_receiver_4 == null ? null : tmp0_safe_receiver_4.f94();
          tmp_20 = !(tmp_21 instanceof Appeal());
        } else {
          tmp_20 = false;
        }
        tmp_19.z9d_1 = tmp_20;
        var tmp_22 = this;
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = this.u8x();
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList().w();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_23 = element.f94();
          var tmp0_safe_receiver_5 = tmp_23 instanceof Accept() ? tmp_23 : null;
          var tmp0_safe_receiver_6 = tmp0_safe_receiver_5 == null ? null : tmp0_safe_receiver_5.o9e_1;
          if (tmp0_safe_receiver_6 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.v(tmp0_safe_receiver_6);
          }
        }
        var accepted = toMutableList(destination);
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0_0 = this.u8x();
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination_0 = ArrayList().w();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = tmp0_0.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          var tmp_24 = element_0.f94();
          var tmp0_safe_receiver_7 = isInterface(tmp_24, NeedsApproval()) ? tmp_24 : null;
          var tmp_25;
          if (tmp0_safe_receiver_7 == null) {
            tmp_25 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_26;
            if (accepted.t1(tmp0_safe_receiver_7)) {
              accepted.w3(tmp0_safe_receiver_7);
              tmp_26 = null;
            } else {
              tmp_26 = to(tmp0_safe_receiver_7, element_0);
            }
            tmp_25 = tmp_26;
          }
          var tmp0_safe_receiver_8 = tmp_25;
          if (tmp0_safe_receiver_8 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination_0.v(tmp0_safe_receiver_8);
          }
        }
        tmp_22.a9e_1 = reversed(destination_0);
        var tmp_27 = this;
        var tmp0_safe_receiver_9 = firstOrNull(this.a9e_1);
        tmp_27.b9e_1 = tmp0_safe_receiver_9 == null ? null : tmp0_safe_receiver_9.af_1;
        var tmp_28 = this;
        var tmp0_1 = this.a9e_1;
        var tmp$ret$25;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_1 = tmp0_1.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_1 = _iterator__ex2g4s_1.o1();
            var res = element_1.cf();
            var msg = element_1.df();
            if ((new (Accept())(res, Companion_getInstance_0().h54_1)).q9e(this.n9d_1.j8x(msg.e68_1)).a9d()) {
              tmp$ret$25 = element_1;
              break $l$block;
            }
          }
          tmp$ret$25 = null;
        }
        var tmp0_safe_receiver_10 = tmp$ret$25;
        tmp_28.c9e_1 = tmp0_safe_receiver_10 == null ? null : tmp0_safe_receiver_10.af_1;
        var tmp_29 = this;
        var tmp_30;
        if (this.l9d_1) {
          var tmp0_2 = this.u8x();
          var tmp$ret$26;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var tmp_31;
            if (isInterface(tmp0_2, Collection())) {
              tmp_31 = tmp0_2.i1();
            } else {
              tmp_31 = false;
            }
            if (tmp_31) {
              tmp$ret$26 = false;
              break $l$block_1;
            }
            var _iterator__ex2g4s_2 = tmp0_2.m1();
            while (_iterator__ex2g4s_2.n1()) {
              var element_2 = _iterator__ex2g4s_2.o1();
              var tmp_32 = element_2.f94();
              if (isInterface(tmp_32, NeedsApproval())) {
                tmp$ret$26 = true;
                break $l$block_1;
              }
            }
            tmp$ret$26 = false;
          }
          tmp_30 = tmp$ret$26;
        } else {
          tmp_30 = false;
        }
        tmp_29.d9e_1 = tmp_30;
        var tmp_33 = this;
        var tmp_34;
        if (this.l9d_1 && !this.x9d_1) {
          var tmp0_safe_receiver_11 = this.n9e();
          var tmp_35;
          if (tmp0_safe_receiver_11 == null) {
            tmp_35 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_36;
            if (!tmp0_safe_receiver_11.z67_1) {
              var tmp_37 = tmp0_safe_receiver_11.f94();
              tmp_36 = isInterface(tmp_37, NeedsApproval());
            } else {
              tmp_36 = false;
            }
            tmp_35 = tmp_36;
          }
          tmp_34 = tmp_35 === true;
        } else {
          tmp_34 = false;
        }
        tmp_33.e9e_1 = tmp_34;
        this.f9e_1 = this.s9d_1 || this.d9e_1 || this.e9e_1 || this.t9d_1 || this.w9d_1 || this.y9d_1;
      }
      u8x() {
        return this.n9d_1.h9e_1;
      }
      n9e() {
        return lastOrNull(this.u8x());
      }
      v8w() {
        return this.n9d_1.v8w();
      }
      u8w() {
        return this.n9d_1.u8w();
      }
      t8w() {
        return this.u8w();
      }
      n8w() {
        return this.n9d_1.n8w();
      }
      g8x() {
        return this.n9d_1.g8x();
      }
      c8y() {
        return this.s9d_1;
      }
      d8y() {
        var tmp;
        if (!this.l9d_1 && !(this.m9d_1 == null) && this.m9d_1.d4(MemberRole_Manager_getInstance()) >= 0 && !this.v8w()) {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = this.u8x();
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!element.z67_1) {
              destination.v(element);
            }
          }
          // Inline function 'kotlin.let' call
          var it = takeLast(destination, 2);
          var tmp_0;
          if (it.p1() < 2) {
            tmp_0 = true;
          } else {
            var tmp$ret$3;
            $l$block_0: {
              // Inline function 'kotlin.collections.all' call
              var tmp_1;
              if (isInterface(it, Collection())) {
                tmp_1 = it.i1();
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp$ret$3 = true;
                break $l$block_0;
              }
              var _iterator__ex2g4s_0 = it.m1();
              while (_iterator__ex2g4s_0.n1()) {
                var element_0 = _iterator__ex2g4s_0.o1();
                if (!equals(element_0.f94(), MoreInfo_instance)) {
                  tmp$ret$3 = false;
                  break $l$block_0;
                }
              }
              tmp$ret$3 = true;
            }
            tmp_0 = !tmp$ret$3;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      x8y() {
        var tmp0_safe_receiver = this.k9d_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k63_1;
        return (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.a9d()) === true;
      }
    }
    initMetadataForClass($, 'IncidentFlowPermissions');
    IncidentFlowPermissionsClass = $;
  }
  return IncidentFlowPermissionsClass;
}
function rewind($this, _this__u8e3s4, messages, timestamp, compare) {
  if (messages.i1()) {
    var tmp0_safe_receiver = _this__u8e3s4.h63_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (compare(tmp0_safe_receiver.q54_1, timestamp)) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return _this__u8e3s4.o63(VOID, VOID, VOID, VOID, tmp);
  }
  var messagesBefore = dropLast(messages, 1);
  var last_0 = last(messages);
  var history = IncidentHistory().r9e(rewind($this, _this__u8e3s4, messagesBefore, last_0.e68_1, compare), messagesBefore);
  var tmp1_safe_receiver = _this__u8e3s4.h63_1;
  var tmp_1;
  if (tmp1_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_2;
    if (compare(tmp1_safe_receiver.q54_1, timestamp)) {
      tmp_2 = tmp1_safe_receiver;
    } else {
      tmp_2 = null;
    }
    tmp_1 = tmp_2;
  }
  var tmp_3 = tmp_1;
  var tmp2_safe_receiver = lastOrNull(messages);
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.f94();
  var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.q9e(history);
  var tmp_4;
  if (tmp4_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_5;
    if (!tmp4_safe_receiver.equals(IncidentState_Filed_getInstance())) {
      tmp_5 = tmp4_safe_receiver;
    } else {
      tmp_5 = null;
    }
    tmp_4 = tmp_5;
  }
  var tmp5_elvis_lhs = tmp_4;
  var tmp6_elvis_lhs = tmp5_elvis_lhs == null ? history.h8w() : tmp5_elvis_lhs;
  return _this__u8e3s4.o63(VOID, VOID, VOID, VOID, tmp_3, VOID, VOID, tmp6_elvis_lhs == null ? IncidentState_Filed_getInstance() : tmp6_elvis_lhs);
}
function rewind_0($this, timestamp, compare) {
  // Inline function 'kotlin.collections.takeWhile' call
  var this_0 = $this.h9e_1;
  var list = ArrayList().w();
  var _iterator__ex2g4s = this_0.m1();
  $l$loop: while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    if (!compare(item.e68_1, timestamp))
      break $l$loop;
    list.v(item);
  }
  var messages = list;
  var tmp0_safe_receiver = $this.g9e_1;
  return IncidentHistory().r9e(tmp0_safe_receiver == null ? null : rewind($this, tmp0_safe_receiver, messages, timestamp, compare), messages);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.s9e_1 = function_0;
      }
      wi(a, b) {
        return this.s9e_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.s9e_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function IncidentHistory$_init_$lambda_z5yhxz(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.e68_1;
  var tmp$ret$1 = b.e68_1;
  return compareValues(tmp, tmp$ret$1);
}
function IncidentHistory$_get_disputeFiledAt_$ref_cn3hp7() {
  return (p0) => p0.k8w();
}
function IncidentHistory$_get_escalationLevel_$ref_v5k1lb() {
  return (p0) => p0.n8w();
}
function IncidentHistory$atTime$lambda(a, b) {
  return a.y26(b) <= 0;
}
function IncidentHistory$before$lambda(a, b) {
  return a.y26(b) < 0;
}
var IncidentHistoryClass;
function IncidentHistory() {
  if (IncidentHistoryClass === VOID) {
    class $ {
      static r9e(incident, messages) {
        var $this = createThis(this);
        $this.g9e_1 = incident;
        $this.h9e_1 = messages;
        var tmp = $this;
        var tmp0_safe_receiver = firstOrNull($this.h9e_1);
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_1;
          var tmp_2 = tmp0_safe_receiver.f94();
          var tmp0_safe_receiver_0 = tmp_2 instanceof FileIncident() ? tmp_2 : null;
          if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.u9e_1) === true) {
            tmp_1 = tmp0_safe_receiver.e68_1;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        tmp.i9e_1 = tmp_0;
        var tmp_3 = $this;
        tmp_3.j9e_1 = lazy(() => {
          var tmp0 = $this.h9e_1;
          var tmp$ret$3;
          $l$block: {
            // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp;
              var tmp_0 = element.f94();
              var tmp0_safe_receiver = tmp_0 instanceof ClientResponse() ? tmp_0 : null;
              if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v9e_1) === true) {
                tmp = element.e68_1;
              } else {
                tmp = null;
              }
              var result = tmp;
              if (!(result == null)) {
                tmp$ret$3 = result;
                break $l$block;
              }
            }
            tmp$ret$3 = null;
          }
          return tmp$ret$3;
        });
        var tmp_4 = $this;
        tmp_4.k9e_1 = lazy(() => {
          var tmp0 = $this.h9e_1;
          var tmp$ret$4;
          $l$block_0: {
            // Inline function 'kotlin.collections.count' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$4 = 0;
              break $l$block_0;
            }
            var count = 0;
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (get_isSignOff(element.f94())) {
                count = count + 1 | 0;
                checkCountOverflow(count);
              }
            }
            tmp$ret$4 = count;
          }
          return tmp$ret$4;
        });
        var tmp_5 = $this;
        tmp_5.l9e_1 = lazy(() => {
          var tmp;
          var tmp0_safe_receiver = $this.g9e_1;
          if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h63_1) == null)) {
            tmp = null;
          } else {
            if ($this.v8w()) {
              tmp = EscalationLevel_Disputed_getInstance();
            } else {
              if ($this.u8w()) {
                tmp = EscalationLevel_Issue_getInstance();
              } else {
                tmp = null;
              }
            }
          }
          return tmp;
        });
        return $this;
      }
      static m9e(item, messages) {
        // Inline function 'kotlin.collections.sortedBy' call
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp = IncidentHistory$_init_$lambda_z5yhxz;
        var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp);
        var tmp$ret$1 = sortedWith(messages, tmp$ret$0);
        return this.r9e(item, tmp$ret$1);
      }
      x8w() {
        return lastOrNull(this.h9e_1);
      }
      u8w() {
        return !(this.i9e_1 == null);
      }
      k8w() {
        var tmp0 = this.j9e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('disputeFiledAt', 1, tmp, IncidentHistory$_get_disputeFiledAt_$ref_cn3hp7(), null);
        return tmp0.f2();
      }
      v8w() {
        return !(this.k8w() == null);
      }
      n8w() {
        var tmp0 = this.l9e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('escalationLevel', 1, tmp, IncidentHistory$_get_escalationLevel_$ref_v5k1lb(), null);
        return tmp0.f2();
      }
      h8w() {
        var tmp0_safe_receiver = this.n8w();
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f9c();
      }
      g8x() {
        var tmp0_elvis_lhs = this.h8w();
        return tmp0_elvis_lhs == null ? IncidentState_Filed_getInstance() : tmp0_elvis_lhs;
      }
      x9e() {
        var tmp0_safe_receiver = this.g9e_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k63_1;
      }
      h8x() {
        var tmp0_elvis_lhs = this.x9e();
        return tmp0_elvis_lhs == null ? IncidentState_Filed_getInstance() : tmp0_elvis_lhs;
      }
      i8x(timestamp) {
        return rewind_0(this, timestamp, IncidentHistory$atTime$lambda);
      }
      j8x(timestamp) {
        return rewind_0(this, timestamp, IncidentHistory$before$lambda);
      }
      toString() {
        return 'IncidentHistory(incident=' + toString_0(this.g9e_1) + ', messages=' + toString(this.h9e_1) + ')';
      }
      hashCode() {
        var result = this.g9e_1 == null ? 0 : this.g9e_1.hashCode();
        result = imul(result, 31) + hashCode(this.h9e_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IncidentHistory()))
          return false;
        if (!equals(this.g9e_1, other.g9e_1))
          return false;
        if (!equals(this.h9e_1, other.h9e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IncidentHistory');
    IncidentHistoryClass = $;
  }
  return IncidentHistoryClass;
}
//region block: exports
export {
  IncidentFlowPermissions as IncidentFlowPermissions44pkdokiuf55,
  IncidentHistory as IncidentHistory100uyzm3w697n,
};
//endregion

//# sourceMappingURL=IncidentFlowPermissions.mjs.map
